import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { phoneReFormat } from "../../utils/helper";
import { phoneRegex } from "../../utils/constants";

export function phoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value) {
            const value = control.value.replace(/\s/g, "");
            const formattedValue = phoneReFormat(value);
            const regexTest = phoneRegex.test(formattedValue);
            if (!regexTest|| formattedValue.length !== 10) {
                return { 'no-valid-format': true };
            }
        }
        return null;
    }
}